import * as React from "react";
import { themeColors, themeTextColors } from "@common/constants";
import { ProductTopic, ProductPhase } from "@modules/tasks/types";
import { ICONS_BY_PLAYBOOK_DOMAIN } from "@modules/tasks/constants";

interface WealthPlaybookDomainMiniDisplayProps {
  progress?: number;
  playbookDomain: ProductTopic | ProductPhase.PHASE_1;
}

const WealthPlaybookDomainMiniDisplay: React.FC<
  WealthPlaybookDomainMiniDisplayProps
> = ({ playbookDomain, progress = 0 }) => {
  const [offset, setOffset] = React.useState(0);
  const CIRCLE_RADIUS = 23;
  const CIRCLE_STROKE_WIDTH = 4;
  const CIRCLE_RADIUS_WITH_BORDER = CIRCLE_RADIUS + CIRCLE_STROKE_WIDTH / 2;
  const CIRCLE_STROKE_LENGTH = 2 * Math.PI * CIRCLE_RADIUS;
  React.useEffect(() => {
    const progressOffset = ((100 - progress) / 100) * CIRCLE_STROKE_LENGTH;
    setOffset(progressOffset);
  }, [CIRCLE_STROKE_LENGTH, progress]);

  const sharedCircleProps = {
    strokeLinecap: "round",
    strokeWidth: CIRCLE_STROKE_WIDTH,
    vectorEffect: "non-scaling-stroke",
    shapeRendering: "auto",
    r: CIRCLE_RADIUS,
    cx: CIRCLE_RADIUS_WITH_BORDER,
    cy: CIRCLE_RADIUS_WITH_BORDER,
  } as const;
  const IconComponent = ICONS_BY_PLAYBOOK_DOMAIN[playbookDomain];

  return (
    <div
      className="relative h-[50px] w-[50px]"
      data-testid="wealth-playbook-domain-mini-display"
    >
      <svg className="absolute inset-0 h-full w-full">
        <circle
          {...sharedCircleProps}
          stroke={themeTextColors["primary"]}
          fill={progress > 0 ? themeColors.green[2] : themeColors.green[4]}
        />
        <circle
          {...sharedCircleProps}
          stroke={progress > 0 ? themeColors.data.green : themeColors.green[5]}
          fill="transparent"
          strokeDasharray={CIRCLE_STROKE_LENGTH}
          strokeDashoffset={progress > 0 ? offset : 0}
          style={{
            transition: "stroke-dashoffset 0.3s ease-out",
          }}
          transform={`rotate(-90 ${CIRCLE_RADIUS_WITH_BORDER} ${CIRCLE_RADIUS_WITH_BORDER})`}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <IconComponent
          width={24.88} // Width of the image
          height={24.88} // Height of the image
          color="white"
        />
      </div>
    </div>
  );
};

export default WealthPlaybookDomainMiniDisplay;
